import {
  Map,
  List,
  OrderedMap
} from 'immutable';

import {
  ADD_FILES_TO_ACTIVITY,
  ADD_INFLIGHT_ACTIVITY,
  RESET_ACTIVITY,
  REMOVE_FAILED_ACTIVITY,
  REMOVE_FILE_FROM_ACTIVITY,
  REMOVE_INFLIGHT_ACTIVITY,
  SAVE_SHARE_ACTIVITY,
  SUBMIT_ACTIVITY_START,
  SUBMIT_ACTIVITY_FAILURE,
  UPDATE_ACTIVITY_STATUS,
  STORE_ACTIVITY_TEXT
} from './actions';

export const initialState = new Map({
  status: new Map({
    isSending: false,
    isTyping: false
  }),
  inFlightActivities: new OrderedMap(),
  activityFailures: new OrderedMap(),
  shareActivity: undefined,
  files: new OrderedMap(),
  text: '',
  cleanText: '',
  object: new Map({
    mentions: new List(),
    content: undefined,
    displayName: ''
  })
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_FILES_TO_ACTIVITY: {
      const files = action.payload.files.reduce((o, currentFile) =>
        Object.assign({}, o, {
          [currentFile.id]: currentFile
        }),
      {});

      return state.mergeIn(['files'], files);
    }

    case ADD_INFLIGHT_ACTIVITY: {
      const {activity} = action.payload;
      const inFlightActivity = new Map([[activity.clientTempId, activity]]);

      return state.mergeIn(['inFlightActivities'], inFlightActivity);
    }

    case REMOVE_FAILED_ACTIVITY: {
      const activityId = action.payload.id;

      return state.deleteIn(['activityFailures', activityId]);
    }

    case REMOVE_FILE_FROM_ACTIVITY: {
      return state.deleteIn(['files', action.payload.id]);
    }

    case REMOVE_INFLIGHT_ACTIVITY: {
      const activityId = action.payload.id;

      return state.deleteIn(['inFlightActivities', activityId]);
    }

    case RESET_ACTIVITY: {
      const inFlightActivities = state.get('inFlightActivities');
      const activityFailures = state.get('activityFailures');

      return initialState
        .set('inFlightActivities', inFlightActivities)
        .set('activityFailures', activityFailures);
    }

    case SAVE_SHARE_ACTIVITY: {
      return state.set('shareActivity', action.payload.shareActivity);
    }

    case SUBMIT_ACTIVITY_START: {
      return state
      // Clear the text from the input
        .set('object', initialState.get('object'))
        .setIn(['status', 'isSending'], true);
    }

    case SUBMIT_ACTIVITY_FAILURE: {
      const {activity} = action.payload;
      const failedActivity = new Map([[activity.clientTempId, activity]]);

      return state
        .deleteIn(['inFlightActivities', activity.id])
        .mergeIn(['activityFailures'], failedActivity);
    }

    case UPDATE_ACTIVITY_STATUS:
      return state.mergeDeepIn(['status'], action.payload.status);

    case STORE_ACTIVITY_TEXT:
      return state
        .set('text', action.payload.text)
        .set('cleanText', action.payload.cleanText);

    default:
      return state;
  }
}
